var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMarkerBlack({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 38,
    viewBox: "0 0 28 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_6743_26684)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.04297 17.5033C1.11793 16.8429 3.24721 14.7753 3.82259 14.1723L8.4083 9.37801L13.8395 3.66187C14.7028 2.75464 15.8397 1.50428 16.7377 0.655836C17.0182 0.389358 17.3578 0.192392 17.7281 0.0808257C19.0179 -0.297268 20.4412 0.739051 21.6044 1.37116C22.5397 1.89483 23.4711 2.4267 24.397 2.9667C25.2677 3.47339 26.417 3.99657 26.7084 5.04446C26.8306 5.47717 26.844 5.93341 26.7467 6.37248C26.5684 7.21228 26.0308 8.78721 25.7582 9.67567L23.9104 15.7526L21.3617 24.0243C21.0345 25.0712 20.3847 27.4228 19.9026 28.2674C19.8907 28.2889 19.8778 28.3102 19.8649 28.3314C18.7652 28.1914 17.6904 27.3502 16.7496 26.7591L13.1782 24.5059C12.502 24.0759 11.7122 23.5411 11.0246 23.1485V23.123C10.6026 22.9173 10.1732 22.7026 9.75566 22.4797C7.04505 21.0335 4.21032 19.7748 1.55729 18.2332C1.33091 18.1016 1.16013 17.7345 1.04297 17.5033Z",
    fill: "#323233"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.04297 17.5033C1.11793 16.8429 3.24721 14.7753 3.82259 14.1723L8.4083 9.37801L13.8395 3.66187C14.7028 2.75464 15.8397 1.50428 16.7377 0.655836C17.0182 0.389358 17.3578 0.192392 17.7281 0.0808257C19.0179 -0.297268 20.4413 0.739051 21.6044 1.37116C21.3726 1.69047 21.1859 2.44194 20.9878 2.86646C20.4676 3.98356 19.9428 5.09848 19.4116 6.21056C17.5708 10.0467 15.6957 13.8662 13.7863 17.6688L11.9793 21.2579C11.6968 21.8173 11.3309 22.6064 11.0246 23.123C10.6026 22.9173 10.1732 22.7026 9.75566 22.4797C7.04505 21.0335 4.21032 19.7748 1.55729 18.2332C1.33091 18.1016 1.16013 17.7345 1.04297 17.5033Z",
    fill: "#3E3E3E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.04009 17.5039C1.15726 17.7351 1.32803 18.1023 1.55442 18.2338C4.20744 19.7754 7.04217 21.0341 9.75279 22.4803C10.1703 22.7032 10.5997 22.918 11.0217 23.1236V23.1491C11.7093 23.5417 12.4991 24.0765 13.1753 24.5066L16.7468 26.7597C17.6875 27.3508 18.7624 28.192 19.862 28.332C18.4734 29.8446 17.2958 29.3714 15.5176 29.569C13.1182 29.8357 11.2143 31.5798 9.77066 33.3862C9.2896 33.9878 8.73805 34.8945 7.85337 34.4867C7.2899 33.3554 6.73636 32.9795 5.74346 32.2797L5.70772 32.2749C5.03999 31.6698 2.88341 30.9848 1.96349 30.7368C1.57626 30.4879 1.31562 30.2212 1.38215 29.7366C1.66364 28.1043 2.26434 26.7763 2.43214 25.0943C2.69278 22.4838 0.857897 19.9687 1.04009 17.5039Z",
    fill: "#FBC66B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.0204 23.1465C11.708 23.5391 12.4979 24.0738 13.174 24.5039L16.7455 26.757C17.6863 27.3481 18.7611 28.1894 19.8607 28.3293C18.4722 29.8419 17.2946 29.3687 15.5163 29.5664C13.1169 29.833 11.2131 31.5771 9.76939 33.3835C9.28833 33.9851 8.73677 34.8919 7.8521 34.4841C7.28863 33.3528 6.73509 32.9768 5.74219 32.277C5.83056 32.114 5.97304 31.9547 6.07282 31.7941C7.82926 28.9797 9.33103 25.9994 11.0204 23.1465Z",
    fill: "#F5A623"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.96233 30.7402C2.88218 30.9881 5.03861 31.6731 5.70628 32.2782L5.74202 32.283C6.73485 32.9827 7.28835 33.3586 7.85178 34.4899C6.45438 35.8899 5.5385 36.1392 3.62929 36.6202C2.44435 36.9188 0.543573 37.5591 0 35.9635C0.180695 34.7789 1.40734 31.8954 1.96233 30.7402Z",
    fill: "#3E3E3E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.70628 32.2754L5.74202 32.2802C6.73485 32.9799 7.28835 33.3559 7.85178 34.4871C6.45438 35.8872 5.5385 36.1364 3.62929 36.6174C2.44435 36.9161 0.543573 37.5564 0 35.9607C0.812133 35.8128 1.96381 35.4215 2.7551 35.1311C4.30639 34.5616 5.04556 33.7424 5.70628 32.2754Z",
    fill: "#323233"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_6743_26684",
    x: 0,
    y: 0,
    width: 27.8105,
    height: 38.002,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_6743_26684"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_6743_26684",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarkerBlack);
export default __webpack_public_path__ + "static/media/marker-black.228137ab2abc93433a92f393e0825979.svg";
export { ForwardRef as ReactComponent };